
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useFamilyForm } from "./FamilyFormContext";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

export function ParentsSection() {
  const { motherName, setMotherName, fatherName, setFatherName } = useFamilyForm();
  const { language } = useLanguage();

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="motherName">
          {language === 'ja' ? '母親の名前' : "Mother's Name"}
        </Label>
        <Input 
          id="motherName" 
          value={motherName} 
          onChange={(e) => setMotherName(e.target.value)} 
          placeholder={language === 'ja' ? "母親の名前を入力" : "Enter mother's name"}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="fatherName">
          {language === 'ja' ? '父親の名前' : "Father's Name"}
        </Label>
        <Input 
          id="fatherName" 
          value={fatherName} 
          onChange={(e) => setFatherName(e.target.value)} 
          placeholder={language === 'ja' ? "父親の名前を入力" : "Enter father's name"}
        />
      </div>
    </>
  );
}
